import Indentification from "../../../../elements/Indentification";
import { initialsValue } from "../../../../../helpers";

const RightAvatar = ({ alt, src }) => {
  return (
    <div className="relative flex-none hidden w-10 h-10 ml-4 chat-text-box__photo sm:block image-fit">
      <Indentification image={src} alt={alt} initial={initialsValue(alt)} />
    </div>
  );
};

export default RightAvatar;
